import React, {useState} from 'react'
import Typical from 'react-typical'
import { HeroContainer, HeroH1, HeroH2, HeroH3 } from './HeroElements'
import Navbar from '../Navbar'
import Sidebar from '../Sidebar';
//import Particles from 'react-particles-js';
//import particlesConfig from './config/particlesConfig';
//import ParticleBackground from './ParticleBackground';
//import { particlesJS } from 'tsparticles';
//import {Link} from 'react-scroll';
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'
function Hero() {

    
    const phrases = ["<Welcome/>","<Bonjour/>","<Ciao/>","<Szia/>","<Dobry den/>","<Hola/>", 
    "<Zdravstvuyte/>","<Olá/>", "<Hallo/>","<Hej/>","<Tere/>","<Ahoj/>",
    "<Zdraveĭte/>", "<Góðan dag/>", "<Geia sas/>", "<Cześć/>", "<Salut/>", "<Zdravo/>",
    "<Hello/>"];


    const [isOpen, setIsOpen] = useState(false)
    const toggle = () =>{
        setIsOpen(!isOpen)
    }
    return (
        
        
        
        

        <HeroContainer id="home">
            <Navbar toggle={toggle}/>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <HeroH1>{''}<TextScrambler phrases={phrases}
                          speed={30}
                          pauseTime={850}/>{''}</HeroH1> 
            <HeroH2>My name is Kovács Bálint Hunor,</HeroH2>
            <HeroH3>And I'm a{' '} 
                <Typical loop={Infinity} 
                wrapper="b"
                steps={[
                    'developer',
                    1000,
                    'student',
                    1000,
                    'guitarist',
                    1000
                ]}
                />
            </HeroH3>
        </HeroContainer>
    )
}

export default Hero
